import * as React from "react";
import * as cls from "./FormField.module.scss";
export { FormField };
/**
 * Контейнер для компонентов ввода данных.
 * 
 * Используется только для создания новых компонентов ввода данных.
 * 
 * @summary Контейнер для компонентов ввода данных.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} [props.label] - Надпись с описанием поля.
 * @param {string} [props.labelFor] - Идентификатор элемента ввода.
 * @param {boolean} [props.required] - Обязательное для заполнения.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {JSX.Element} props.children - Содержимое элемента.
 * @returns {JSX.Element} Элемент JSX.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function FormField({
  label,
  labelFor,
  required,
  className,
  children
}) {
  let fullClassName = cls.form_field;
  if (className) fullClassName += " " + className;
  const widgetRequired = required ?
    <span className={cls.form_field_required}></span> :
    null;
  let widgetLabel = label ?
    <label htmlFor={labelFor}>
      {widgetRequired}{label}
    </label> :
    null;
  return (
    <div className={fullClassName}>
      {widgetLabel}
      {children}
    </div>
  );
}
